import { Quill } from 'react-quill';

import { fonts } from '../toolbarOptions';

const Size = Quill.import('attributors/style/size');
Size.whitelist = fonts('16px');
export { Size };
